export default {
  computed: {
    allFacilityTypes: function () {
      return this.$store.state.FacilityTypeStore.all_facility_types
    },
    allFacilityAllocation: function () {
      return this.$store.state.FacilityAllocationStore.facility_allocations
    },
    singleFacilityAvailabilityData: function () {
      return this.$store.state.FacilityStore.all_activities
    },
    singleFacility: function () {
     
      return this.$store.state.FacilityStore.facilities[index]
    },
    accommodationTypes: function () {
      return this.$store.state.AccommodationTypeStore.all_accommodation_types
    }
  }
}
